module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"padded\">\n	<table class=\"form-table\">\n		<tr>\n			<td>ФИО физ. лица</td>\n			<td><control type=\"text\" target=\"item.indname\"/></td>\n		</tr>\n		<tr>\n			<td>Наименование юр. лица</td>\n			<td><control type=\"text\" target=\"item.orgname\"/></td>\n		</tr>\n		<tr>\n			<td>Должность физ. лица</td>\n			<td><control type=\"text\" target=\"item.position\"/></td>\n		</tr>\n		<tr>\n			<td colspan=\"2\" class=\"meta-responsibleparty-contact\">\n				<button on-click=\"addContact\">Добавить контактную информацию</button>\n			</td>\n		</tr>\n		<tr>\n			<td>Функции</td>\n			<td><control type=\"select\" source=\"roles\" title-key=\"value\" value-key=\"id\" target=\"item.roleid\"/></td>\n		</tr>\n	</table>\n</div>\n")
  }
  return __output.join("");

}